module["exports"] = [
  "Leil. ###",
  "Oppgang A",
  "Oppgang B"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nb_NO/address/secondary_address.js
// module id = 3228
// module chunks = 1609